import { h } from 'preact';

import FieldBase from 'components/editor/settings/fieldBase';

export default class FieldWrapper extends FieldBase {
	get labelFor() {
		return null;
	}

	renderField() {
		return this.props.children;
	}
}